import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpViewData implements IOpData, IOpChangeState {
    //Properties
    public idViewData: number
    public idView: number
    public idDataType: number
    public indexNbr: number
    public value: any
    //Properties end

    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpData implementation
    public get idData() { return this.idViewData }
    //get idDataType() { return this.idDataType }
    public get indexNBR() { return this.indexNbr }
    //get value() { return this.value }
    //IOpData implementation end

    public static fromIOpData(data: IOpData): OpViewData {
        var newData: OpViewData = new OpViewData(null)
        newData.idViewData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState
        return newData
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idViewData = opObj.ID_VIEW_DATA
            this.idView = opObj.ID_VIEW
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            if (opObj._DataType)
                this.dataType = new OpDataType(opObj._DataType)

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_VIEW_DATA: this.idViewData,
            ID_VIEW: this.idView,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            OpState: this.opState
        }
    }
}